module.exports = __webpack_public_path__ + "EXCEL.png";